import { produce } from 'immer';
import { textDiff } from 'app/utils/textDiff';
export function actionDiff(actions, actionsBefore) {
    const cleanForDiff = (action) => {
        return produce(action, (draft) => {
            delete draft.childIds;
            delete draft.isEditable;
            delete draft.badges;
            delete draft.isRemovable;
            delete draft.text;
        });
    };
    const before = JSON.stringify(actionsBefore.map(cleanForDiff), null, 2);
    const after = JSON.stringify(actions.map(cleanForDiff), null, 2);
    return textDiff(before, after);
}
